import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { List } from '@tesla/design-system-react';
import classnames from 'classnames';
import Tab from './Tab/index.js';
import { useTabConfigContext } from '../Context/index.js';
import Styles from '../vehicleTabs.module.css.js';

var Tabs = function Tabs() {
  var _useTabConfigContext = useTabConfigContext(),
    navConfig = _useTabConfigContext.navConfig,
    className = _useTabConfigContext.className,
    loading = _useTabConfigContext.loading;
  var tabsInfo = navConfig || [];
  if (loading) {
    return null;
  }
  return /*#__PURE__*/React.createElement(List, {
    className: classnames('tds-site-nav-items', 'tds-site-nav-items--vertical', Styles['tw-react--vehicle-tabs--tabs'], className)
  }, tabsInfo.map(function (tabProps) {
    return /*#__PURE__*/React.createElement(Tab, _extends({}, tabProps, {
      key: tabProps === null || tabProps === void 0 ? void 0 : tabProps.id
    }));
  }));
};

export { Tabs as default };
